import React, { useState, useEffect } from "react";
import { t } from "i18next";
import styles from "./PlaylistRedirect.module.css";
export const PlaylistRedirect = ({ cover }) => {
    const [time, setTime] = useState(5);
    useEffect(() => {
        const interval = setInterval(() => {
            setTime((prevTime) => {
                if (prevTime === 0) {
                    clearInterval(interval);
                    return prevTime;
                }
                return prevTime - 1;
            });
        }, 1000);
        return () => clearInterval(interval); // Clean up the interval
    }, []);
    return (React.createElement("div", { className: styles.container },
        React.createElement("div", { className: styles.bakcground, style: { backgroundImage: cover !== null && cover !== void 0 ? cover : "" } }),
        React.createElement("span", { className: styles.typography }, t("playlist.redirect") + time)));
};
//# sourceMappingURL=index.js.map